<template>
    <div class="popup-container">
        <vue-draggable-resizable
            v-for="chat in chats"
            :key="chat.id"
            :w="CHAT_WIDTH"
            :h="'auto'"
            :x="chat.x || 0"
            :y="chat.y || 0"
            :resizable="false"
            :z="chat.z"
            :on-drag-start="() => onDragStart(chat)"
            class="popup"
        >
            <ChatComponent
                :call-id="chat.callId"
                :bot-id="chat.botId"
            />
        </vue-draggable-resizable>
    </div>
</template>

<script setup lang="ts">
import VueDraggableResizable from 'vue-draggable-resizable'
import ChatComponent from '@/components/RedesignComponents/Cards/Voicebots/ChatComponent.vue'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import { chats, Chat, CHAT_WIDTH } from '@/composables/useChatsData'


function onDragStart (chat: Chat) {
    const maxIndex = Math.max(...chats.value.map(chat => chat.z))
    chat.z = maxIndex + 1
}

</script>

<style scoped lang="scss">
.popup-container {
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
}

.popup {
  border: none;
}
</style>
